import script from "./AddButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddButton.vue?vue&type=script&setup=true&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=a9e3a57e&scoped=true&lang=css"

import exportComponent from "/home/honza/Dokumenty/conference/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9e3a57e"]])

export default __exports__